<template>
  <b-modal
    id="ModId2"
    ref="modal"
    :title="modalTitle"
    size="lg"
    @ok="sendModalData($event)"
    @cancel="clearModal"
    @hidden="clearModal"
    ok-title="Сохранить"
    ok-variant="success"
    cancel-variant="danger"
    cancel-title="Отменить"
    :no-close-on-backdrop=true
    :ok-disabled="veeErrors.any()"
  >
    <b-container fluid v-if="!loading">
      <div class="modal-spinner">
        <b-spinner variant="secondary" label="Loading..."></b-spinner>
        <strong class="mt-3">Загрузка...</strong>
      </div>
    </b-container>
    <b-form ref="form" @submit.stop.prevent="onSubmit" v-else>
      <b-container fluid>
        <b-row class="pb-3">
          <b-col md="7" class="pl-0">
            <b-form-group
              label="ФИО *"
              label-for="fullname-input"
              label-class="mf-label"
              :invalid-feedback="getError('fullname-input')"
            >
              <b-form-input
                id="fullname-input"
                name="fullname-input"
                v-model="model.p_fullname"
                v-validate="modelValidation.fio"
                data-vv-as="ФИО"
                placeholder="ФИО"
                :state="validateState('fullname-input')"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="5" class="pr-0">
            <b-form-group
              label="Email *"
              label-for="email-input"
              label-class="mf-label"
              :invalid-feedback="getError('email-input')"
            >
              <b-form-input
                id="email-input"
                name="email-input"
                v-model="model.p_email"
                v-validate="modelValidation.email"
                data-vv-as="Email"
                placeholder="Email"
                :disabled="model.p_notification"
                :state="validateState('email-input')"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="pb-3">
          <b-col md="4" class="pl-0">
            <b-form-group
              style="position: relative;"
              label="Логин *"
              label-for="name-input"
              label-class="mf-label"
              :invalid-feedback="getError('name-input')"
            >
              <b-form-input
                id="name-input"
                name="name-input"
                v-model="model.p_name"
                placeholder="Логин"
                :disabled="model.p_notification"
                v-validate="modelValidation.login"
                data-vv-as="Логин"
                :state="validateState('name-input')"
              ></b-form-input>
              <div v-if="!model.p_notification" class="copy-email" @click="() => { return model.p_name = model.p_email }">Скопировать e-mail</div>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="Пароль *"
              label-for="password-input"
              label-class="mf-label"
              :invalid-feedback="getError('password-input')"
            >
              <b-form-input
                id="password-input"
                name="password-input"
                v-model="model.p_pass"
                placeholder="Пароль"
                :disabled="model.p_notification"
                v-validate="modelValidation.password"
                data-vv-as="Пароль"
                :state="validateState('password-input')"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4" class="pr-0">
            <b-form-group
              label="Мобильный телефон"
              label-for="phone-input"
              label-class="mf-label"
            >
              <b-form-input
                id="phone-input"
                v-model="model.p_phone"
                placeholder="+x(xxx)xxx-xx-xx"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="pb-3">
          <b-col md="4" class="pl-0">
            <b-form-group
              label="Роль *"
              label-for="role"
              label-class="mf-label"
              :invalid-feedback="getError('role')"
            >
              <treeselect id="role"
                          name="role"
                          :options="selects.p_rid"
                          v-model="model.p_rid"
                          placeholder="Выбрать..."
                          noResultsText="Ничего не найдено..."
                          :clearable=true
                          :label="'Роль *'"
                          data-vv-as="Роль"
                          v-validate="{required:true}"
              >
                <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col md="8" class="pr-0">
            <b-form-group
              label="Дополнительные опции"
              label-for="options"
              label-class="mf-label"
            >
              <treeselect id="options"
                          :options="selects.p_rights"
                          v-model="model.p_rights"
                          :multiple="true"
                          placeholder="Выбрать..."
                          noResultsText="Ничего не найдено..."
                          :clearable=true
                          :label="'Роль *'"
              >
                <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>
              </treeselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="pb-3">
          <b-col md="12" class="px-0">
            <b-form-group
              label="Комментарии"
              label-for="comments"
              label-class="mf-label"
            >
              <b-form-textarea
                id="comments"
                v-model="model.p_comments"
                placeholder="Дополнительная информация"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="(flag === 'edit') && isAbleToAddEmailSettings()" class="pb-3">
          <b-col md="4" class="px-0">
            <b-form-group
              label="E-mail оповещение"
              label-for="p_notification"
              label-class="mf-label"
            >
              <b-form-checkbox
                @input="checkSelectStatusField"
                id="p_notification"
                class="mt-3"
                v-model="model.p_notification"
                name="p_notification"
              ></b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col md="8" class="px-0">
            <b-form-group
              label="Статусы"
              label-for="select-status"
              label-class="mf-label"
            >
              <treeselect id="select-status"
                          name="select-status"
                          :multiple="true"
                          :options="notificationStatuses"
                          v-model="model.p_statuses"
                          placeholder="Выбрать..."
                          noResultsText="Ничего не найдено..."
                          :clearable=true
                          :label="'Статусы *'"
                          data-vv-as="Статусы"
              >
                <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>
              </treeselect>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>

    </b-form>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { validation } from './validation'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'user',
  mixins: [validation],
  components: {
    Treeselect
  },
  data () {
    return {
      modalData: null,
      loading: null,
      sendMethod: null,
      model: {
        p_fullname: null,
        p_id: null,
        p_name: null,
        p_pass: null,
        p_phone: null,
        p_comments: null,
        p_email: null,
        p_rid: null,
        p_rights: null,
        p_gid: null,
        parent_p_gid: null,
        p_statuses: [],
        p_notification: false,
        p_company: null,
        p_opf: null,
        p_inn: null,
        p_kpp: null
      },
      parent_p_gid: null,
      p_gid: null,
      selects: {
        p_rid: null,
        p_rights: null
      },
      modalTitle: '',
      flag: ''
    }
  },
  watch: {
    modalParamsUser () {
      let rightsArr
      if (this.modalParamsUser.method_data.p_rights !== null) {
        rightsArr = this.modalParamsUser.method_data.p_rights.replace(/{|}/g, '').split(',')
      }
      this.model.p_fullname = this.modalParamsUser.method_data.p_fullname
      this.model.p_name = this.modalParamsUser.method_data.p_name
      this.model.p_pass = this.modalParamsUser.method_data.p_pass
      this.model.p_phone = this.modalParamsUser.method_data.p_phone
      this.model.p_email = this.modalParamsUser.method_data.p_email
      this.model.p_rid = this.modalParamsUser.method_data.p_rid
      this.model.p_statuses = this.modalParamsUser.method_data.p_statuses
      this.model.p_notification = this.modalParamsUser.method_data.p_notification
      this.model.p_rights = rightsArr
      this.model.p_comments = this.modalParamsUser.method_data.p_comments
      this.selects.p_rid = this.modalParamsUser.selects.p_rid
      this.selects.p_rights = this.modalParamsUser.selects.p_rights
    },
    userDropdowns () {
      this.selects.p_rid = this.userDropdowns.p_rid
      this.selects.p_rights = this.userDropdowns.p_rights
    }
  },
  computed: {
    ...mapState(
      {
        modalParamsUser: state => state.groupsUsers.modalParamsUser,
        userDropdowns: state => state.groupsUsers.userDropdowns,
        notificationStatuses: state => state.groupsUsers.notificationStatuses,
        userInfo: state => state.authorization.userInfo
      }
    )
  },
  methods: {
    isAbleToAddEmailSettings () {
      const hasRights = this.userInfo.rights.user.filter(item => {
        return item === 'email_settings'
      })
      return (hasRights.length > 0)
    },
    checkSelectStatusField (e) {
      if (e === false) {
        this.model.p_statuses = []
      }
    },
    modalUser (data) {
      if (data.subgroup_p_gid) {
        this.parent_p_gid = data.p_gid
        this.p_gid = data.subgroup_p_gid
        this.model.parent_p_gid = data.p_gid
        this.model.p_gid = data.subgroup_p_gid
      } else {
        this.model.p_gid = data.p_gid
        this.model.parent_p_gid = null
      }
      if (data.add) {
        this.modalTitle = 'Добавление пользователя'
        this.flag = 'add'
        this.$root.$emit('bv::show::modal', 'ModId2', event)
        this.getUserDropdowns(data).then(
          () => {
            this.modalData = data
            this.loading = true
            this.model.p_pass = this.generatePassword()
            this.sendMethod = 'create'
          }
        )
      } else {
        this.model.p_opf = data.opf
        this.model.p_company = data.orgname
        this.model.p_gid = data.p_gid
        if (data.inn_kpp !== undefined) {
          const innKpp = data.inn_kpp.split(' ')
          this.model.p_inn = innKpp[0]
          this.model.p_kpp = innKpp[2] ? innKpp[2] : ''
        } else {
          this.model.p_inn = '0'
          this.model.p_kpp = '0'
        }
        this.modalTitle = 'Редактирование пользователя'
        this.flag = 'edit'
        this.$root.$emit('bv::show::modal', 'ModId2', event)
        this.getUserModalParams(data).then(
          () => {
            // console.log('getUserModalParams ', data)
            this.modalData = data
            this.loading = true
            this.sendMethod = 'edit'
          }
        )
        this.getNotificationStatuses()
      }
    },
    generatePassword () {
      const length = 8
      const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      let retVal = ''
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n))
      }
      return retVal
    },
    sendLogic () {
      if (this.sendMethod === 'create') {
        this.model.parent_p_gid = this.parent_p_gid
        if (this.parent_p_gid !== null) {
          this.model.p_gid = this.p_gid
        }
        // this.model.p_gid = this.modalData.p_gid
        this.loading = false
        this.createUser(Object.assign({}, this.model)).then(
          () => {
            this.loading = true
            this.$root.$emit('bv::hide::modal', 'ModId2', event)
          },
          (error) => {
            this.loading = true
            console.log(error)
            this.$root.$emit('bv::hide::modal', 'ModId2', event)
          }
        )
      } else if (this.sendMethod === 'edit') {
        this.model.parent_p_gid = this.parent_p_gid
        if (this.parent_p_gid !== null) {
          this.model.p_gid = this.p_gid
        }
        this.loading = false
        this.editUser(Object.assign({}, this.model)).then(
          () => {
            this.loading = true
            this.$root.$emit('bv::hide::modal', 'ModId2', event)
          },
          (error) => {
            this.loading = true
            console.log(error)
            this.$root.$emit('bv::hide::modal', 'ModId2', event)
          }
        )
      }
    },
    sendModalData (event) {
      event.preventDefault()
      // this.onSubmit()
      this.sendLogic()
    },
    clearModal () {
      for (const key in this.model) {
        this.model[key] = null
      }
      this.selects.p_rid = null
      this.selects.p_rights = null
      this.loading = false
      this.parent_p_gid = null
      this.p_gid = null
      this.model.p_statuses = []
      this.model.p_notification = false
    },
    ...mapActions('groupsUsers', [
      'editUser',
      'createUser',
      'getUserDropdowns',
      'getUserModalParams',
      'getNotificationStatuses'
    ])
  }
}
</script>

<style scoped>
  .copy-email {
    position: absolute;
    top: -2px;
    right: 0;
    font-size: 14px;
    text-decoration: underline;
    text-decoration-style: dotted;
    cursor: pointer;
  }
</style>
